import React, { Fragment, PureComponent } from 'react'
import { HomeScreen, LoginScreen } from "./routes";
export default class MainScreen extends PureComponent{
    render(){
        const { loggedIn } = this.props;
        return (
            <Fragment>
                {
                    loggedIn
                    ? <HomeScreen />
                    : <LoginScreen />
                }
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/screens/index.js